import { render } from "./HelloWorld.vue?vue&type=template&id=826d4464&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=826d4464&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-826d4464"

export default script